module.exports = __webpack_public_path__ + "tj.svg?77f4149e3b575a147b570b8cb46b7c30";